import React, { useCallback } from "react";
import ModalConfirm from "components/Modal/ModalConfirm";
import { FormGroup } from "reactstrap";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Tooltip from "@mui/material/Tooltip";

const RenderContestationAction = ({
  currentStage,
  status,
  permissions,
  newMessage,
  setNewMessage,
  score,
  changeScore,
  contestation,
  loading,
  onSubmit,
  nextOrigin,
  originMap,
  maxScore,
  passed,
  setPassed,
  priority,
  setPriority,
}) => {
  const handlerNewMessage = useCallback(
    (e) => {
      setNewMessage(e.target.value);
    },
    [setNewMessage],
  );

  const renderScoreInput = () => (
    <FormGroup>
      <label
        className="form-control-label align-self-center"
        htmlFor="score"
        style={{ display: "flex", alignItems: "center", gap: "6px" }}
      >
        Nova nota:
        {typeof maxScore === "number" && !isNaN(maxScore) ? (
          <Tooltip
            title={`A nota máxima permitida para esta avaliação é ${maxScore}`}
          >
            <WarningAmberIcon
              style={{ color: "#f5b300", fontSize: 18, cursor: "pointer" }}
            />
          </Tooltip>
        ) : (
          <Tooltip title="Esta avaliação não possui nota máxima configurada. O valor máximo não será bloqueado.">
            <WarningAmberIcon
              style={{ color: "#bdbdbd", fontSize: 18, cursor: "pointer" }}
            />
          </Tooltip>
        )}
      </label>
      <input
        className="form-control custom-input ml-2"
        style={{ width: "50px" }}
        onChange={(e) => {
          const value = e.target.value.replace(/[^0-9]/g, "");
          let finalValue = value;
          if (
            typeof maxScore === "number" &&
            !isNaN(maxScore) &&
            value !== "" &&
            Number(value) > maxScore
          ) {
            finalValue = String(maxScore);
          }
          changeScore({ target: { value: finalValue } });
        }}
        value={score}
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="off"
      />
    </FormGroup>
  );

  const renderContestationFields = () => (
    <>
      <FormGroup>
        <label className="form-control-label">O usuário passou na regra?</label>
        <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <input
              type="radio"
              name="passed"
              value="true"
              checked={passed === true}
              onChange={() => setPassed(true)}
            />
            Sim
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <input
              type="radio"
              name="passed"
              value="false"
              checked={passed === false}
              onChange={() => setPassed(false)}
            />
            Não
          </label>
        </div>
      </FormGroup>
      <FormGroup>
        <label className="form-control-label">Este item é crítico?</label>
        <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <input
              type="radio"
              name="priority"
              value="true"
              checked={priority === true}
              onChange={() => setPriority(true)}
            />
            Sim
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <input
              type="radio"
              name="priority"
              value="false"
              checked={priority === false}
              onChange={() => setPriority(false)}
            />
            Não
          </label>
        </div>
      </FormGroup>
    </>
  );

  switch (currentStage) {
    case "INITIAL_DISPUTE":
      if (
        permissions.includes("respond:quality:contestation") &&
        status !== "APPROVED"
      ) {
        return (
          <>
            <label className="form-control-label">
              Comentário para a {originMap[nextOrigin]}:
            </label>
            <textarea
              type="textarea"
              value={newMessage}
              onChange={handlerNewMessage}
              placeholder="Digite sua resposta..."
              style={{
                resize: "none",
                width: "80%",
                height: "100px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
            <>
              {renderScoreInput()}
              {renderContestationFields()}
              <div className="pl-lg-2 d-flex mt-3 mb-3">
                <ModalConfirm
                  id={contestation.id}
                  buttonColor="success"
                  type="button"
                  buttonStyle={{ width: "auto" }}
                  modalText={`Esta ação irá APROVAR a contestação`}
                  disableButton={loading}
                  buttonText="Aprovar"
                  handler={() => onSubmit("APPROVED")}
                />
                <ModalConfirm
                  id={contestation.id}
                  buttonColor="danger"
                  type="button"
                  buttonStyle={{ width: "auto" }}
                  modalText={`Esta ação irá RECUSAR a contestação`}
                  disableButton={loading}
                  buttonText="Recusar"
                  handler={() => onSubmit("REJECTED")}
                />
              </div>
            </>
          </>
        );
      }
      break;

    case "INITIAL_DECISION":
      if (
        status !== "APPROVED" &&
        permissions.includes("create:quality:reply")
      ) {
        return (
          <>
            <label className="form-control-label">
              Comentário para a {originMap[nextOrigin]}:
            </label>
            <textarea
              type="textarea"
              value={newMessage}
              onChange={handlerNewMessage}
              placeholder="Digite sua resposta..."
              style={{
                resize: "none",
                width: "80%",
                height: "100px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
            <ModalConfirm
              id={contestation.id}
              buttonColor="default"
              type="button"
              buttonStyle={{ width: "auto" }}
              modalText={`Esta ação irá enviar uma réplica para a contestação`}
              disableButton={loading}
              buttonText="Enviar"
              handler={() => onSubmit("PENDING")}
            />
          </>
        );
      }
      break;

    case "FIRST_REPLY":
      if (
        permissions.includes("respond:quality:reply") &&
        status !== "APPROVED"
      ) {
        return (
          <>
            <label className="form-control-label">
              Comentário para a {originMap[nextOrigin]}:
            </label>
            <textarea
              type="textarea"
              value={newMessage}
              onChange={handlerNewMessage}
              placeholder="Digite sua resposta..."
              style={{
                resize: "none",
                width: "80%",
                height: "100px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
            <>
              {renderScoreInput()}
              {renderContestationFields()}
              <div className="pl-lg-2 d-flex mt-3 mb-3">
                <ModalConfirm
                  id={contestation.id}
                  buttonColor="success"
                  type="button"
                  buttonStyle={{ width: "auto" }}
                  modalText={`Esta ação irá APROVAR a contestação`}
                  disableButton={loading}
                  buttonText="Aprovar"
                  handler={() => onSubmit("APPROVED")}
                />
                <ModalConfirm
                  id={contestation.id}
                  buttonColor="danger"
                  type="button"
                  buttonStyle={{ width: "auto" }}
                  modalText={`Esta ação irá RECUSAR a contestação`}
                  disableButton={loading}
                  buttonText="Recusar"
                  handler={() => onSubmit("REJECTED")}
                />
              </div>
            </>
          </>
        );
      }
      break;

    case "FIRST_REJOINDER":
      if (
        permissions.includes("create:quality:reply") &&
        status !== "APPROVED"
      ) {
        return (
          <>
            <label className="form-control-label">
              Comentário para a {originMap[nextOrigin]}:
            </label>
            <textarea
              type="textarea"
              value={newMessage}
              onChange={handlerNewMessage}
              placeholder="Digite sua resposta..."
              style={{
                resize: "none",
                width: "80%",
                height: "100px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
            <ModalConfirm
              id={contestation.id}
              buttonColor="default"
              type="button"
              buttonStyle={{ width: "auto", marginBottom: "10px" }}
              modalText={`Esta ação irá enviar uma replica para a contestação`}
              disableButton={loading}
              buttonText="Enviar"
              handler={() => onSubmit("PENDING")}
            />
          </>
        );
      }
      break;

    case "SECOND_REPLY":
      if (
        permissions.includes("respond:quality:final_reply") &&
        status !== "APPROVED"
      ) {
        return (
          <>
            <label className="form-control-label">
              Comentário para a {originMap[nextOrigin]}:
            </label>
            <textarea
              type="textarea"
              value={newMessage}
              onChange={handlerNewMessage}
              placeholder="Digite sua resposta..."
              style={{
                resize: "none",
                width: "80%",
                height: "100px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
            <>
              {renderScoreInput()}
              {renderContestationFields()}
              <div className="pl-lg-2 d-flex mt-3 mb-3">
                <ModalConfirm
                  id={contestation.id}
                  buttonColor="success"
                  type="button"
                  buttonStyle={{ width: "auto" }}
                  modalText={`Esta ação irá APROVAR a contestação`}
                  disableButton={loading}
                  buttonText="Aprovar"
                  handler={() => onSubmit("APPROVED")}
                />
                <ModalConfirm
                  id={contestation.id}
                  buttonColor="danger"
                  type="button"
                  buttonStyle={{ width: "auto" }}
                  modalText={`Esta ação irá RECUSAR a contestação`}
                  disableButton={loading}
                  buttonText="Recusar"
                  handler={() => onSubmit("REJECTED")}
                />
              </div>
            </>
          </>
        );
      }
      break;

    case "FINAL_DECISION":
      return null;

    default:
      return null;
  }
};

export default RenderContestationAction;
